import React from 'react';
import {
  Grid,
  TextField,
  Autocomplete
} from '@mui/material';

/**
 * SupplierInformation component
 * Displays and manages supplier information for purchase invoices
 * 
 * @param {Object} props
 * @param {Object} props.invoice - The invoice data object containing supplier information
 * @param {Array} props.suppliers - List of available suppliers
 * @param {Function} props.handleSupplierChange - Function to handle supplier selection changes
 */
const SupplierInformation = ({ 
  invoice, 
  suppliers, 
  handleSupplierChange 
}) => {
  return (
    <Grid container spacing={0.5}>
      <Grid item xs={12}>
        <Autocomplete
          options={suppliers || []}
          getOptionLabel={(option) => {
            if (!option) return '';
            return option.name || '';
          }}
          isOptionEqualToValue={(option, value) => {
            if (!option || !value) return false;
            return (option.id && value.id && option.id === value.id) || 
                   (option._id && value._id && option._id === value._id);
          }}
          value={invoice.supplier || null}
          onChange={handleSupplierChange}
          renderOption={(props, option) => (
            <li {...props} key={option.id || option._id || `supplier-${Math.random()}`}>
              {option.name || 'Unknown Supplier'}
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select Supplier"
              margin="dense"
              size="small"
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 0,
                  height: 36,
                },
                '& .MuiInputBase-input': {
                  py: 0.75,
                  fontSize: '0.875rem'
                },
                '& .MuiInputLabel-root': {
                  fontSize: '0.875rem'
                },
                '& .MuiSelect-select': {
                  py: 0.75
                }
              }}
            />
          )}
        />
      </Grid>
      {invoice.supplier && invoice.supplier.id !== 0 && (
        <>
          <Grid item xs={12}>
            <TextField
              label="VAT Number"
              value={invoice.supplier.vatNumber}
              fullWidth
              margin="dense"
              size="small"
              InputProps={{
                readOnly: true,
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 0,
                  height: 36,
                },
                '& .MuiInputBase-input': {
                  py: 0.75,
                  fontSize: '0.875rem'
                },
                '& .MuiInputLabel-root': {
                  fontSize: '0.875rem'
                },
                '& .MuiSelect-select': {
                  py: 0.75
                }
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Email"
              value={invoice.supplier.email}
              fullWidth
              margin="dense"
              size="small"
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 0,
                  height: 36,
                },
                '& .MuiInputBase-input': {
                  py: 0.75,
                  fontSize: '0.875rem'
                },
                '& .MuiInputLabel-root': {
                  fontSize: '0.875rem'
                },
                '& .MuiSelect-select': {
                  py: 0.75
                }
              }}
            />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default SupplierInformation;
